import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ROLE_URL = `${backendUrl}/api/role/`;

class RoleService {
	async getAllRoles() {
		try {
			const response = await axios.get(ROLE_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getRole(id) {
		return axios.get(`${ROLE_URL}${id}/`);
	}

	createRole(data) {
		return axios.post(ROLE_URL, data).catch((error) => {
			console.error('Erreur lors de la création du role', error);
			throw error;
		});
	}

	updateRole(id, data) {
		return axios.put(`${ROLE_URL}${id}/`, data);
	}

	deleteRole(id) {
		return axios.delete(`${ROLE_URL}${id}/`);
	}

	getRoleOptions() {
		return this.getAllRoles().then((role) => {
			const options = role.map((role) => ({
				value: role.id,
				label: (role.nom).toUpperCase(),
			}));
			return options;
		});
	}
}

export default new RoleService();
